/**
 * @file: MeIcon.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The icon set of the Me home screen, from the design's own SVG assets. They
 * stroke with `currentColor`, so `color` tints them on native and web alike.
 */

import AltArrowRight from '@euler/app/flows/me/assets/icons/alt-arrow-right.svg';
import BillList from '@euler/app/flows/me/assets/icons/bill-list.svg';
import Bookmark from '@euler/app/flows/me/assets/icons/bookmark.svg';
import Box from '@euler/app/flows/me/assets/icons/box.svg';
import CalendarMark from '@euler/app/flows/me/assets/icons/calendar-mark.svg';
import Calendar from '@euler/app/flows/me/assets/icons/calendar.svg';
import Cart3 from '@euler/app/flows/me/assets/icons/cart-3.svg';
import CartLarge2 from '@euler/app/flows/me/assets/icons/cart-large-2.svg';
import Chart from '@euler/app/flows/me/assets/icons/chart.svg';
import CheckCircle from '@euler/app/flows/me/assets/icons/check-circle.svg';
import ClipboardCheck from '@euler/app/flows/me/assets/icons/clipboard-check.svg';
import CupStar from '@euler/app/flows/me/assets/icons/cup-star.svg';
import Gift from '@euler/app/flows/me/assets/icons/gift.svg';
import Phone from '@euler/app/flows/me/assets/icons/phone.svg';
import PlayCircle from '@euler/app/flows/me/assets/icons/play-circle.svg';
import QuestionCircle from '@euler/app/flows/me/assets/icons/question-circle.svg';
import Restart from '@euler/app/flows/me/assets/icons/restart.svg';
import Settings from '@euler/app/flows/me/assets/icons/settings.svg';
import Share from '@euler/app/flows/me/assets/icons/share.svg';
import Star from '@euler/app/flows/me/assets/icons/star.svg';
import TestTube from '@euler/app/flows/me/assets/icons/test-tube.svg';
import UserPlus from '@euler/app/flows/me/assets/icons/user-plus.svg';
import WalletMoney from '@euler/app/flows/me/assets/icons/wallet-money.svg';
import Wrench from '@euler/app/flows/me/assets/icons/wrench.svg';
import { memo } from 'react';
import { SvgProps } from 'react-native-svg';

const kIcons = {
  'alt-arrow-right': AltArrowRight,
  'bill-list': BillList,
  bookmark: Bookmark,
  box: Box,
  calendar: Calendar,
  'calendar-mark': CalendarMark,
  'cart-3': Cart3,
  'cart-large-2': CartLarge2,
  chart: Chart,
  'check-circle': CheckCircle,
  'clipboard-check': ClipboardCheck,
  'cup-star': CupStar,
  gift: Gift,
  phone: Phone,
  'play-circle': PlayCircle,
  'question-circle': QuestionCircle,
  restart: Restart,
  settings: Settings,
  share: Share,
  star: Star,
  'test-tube': TestTube,
  'user-plus': UserPlus,
  'wallet-money': WalletMoney,
  wrench: Wrench,
};

export type MeIconName = keyof typeof kIcons;

export const MeIcon = memo(
  ({
    name,
    size,
    color,
    style,
  }: {
    name: MeIconName;
    size: number;
    color: string;
    style?: SvgProps['style'];
  }) => {
    const Svg = kIcons[name];
    return <Svg width={size} height={size} color={color} style={style} />;
  },
);
